<div class="score-cards-container">
    <div class="header">
        <h2>{{ title }}</h2>
        <p class="subtitle">Compare brands with clear, easy-to-read score cards</p>
    </div>

    <div class="cards-grid">
        <mat-card *ngFor="let uni of processedUniversities; let i = index" class="university-card">
            <mat-card-header>
                <div class="rank-badge">
                    <span class="rank-number">{{ i + 1 }}</span>
                </div>
                <mat-card-title>{{ uni.name }}</mat-card-title>
                <mat-card-subtitle>
                    <div class="overall-score">
                        <mat-icon [style.color]="uni.overallColor">{{ uni.overallIcon }}</mat-icon>
                        <span class="score-value">{{ uni.overallScore }}</span>
                        <span class="score-label">{{ getScoreLabel(uni.overallScore) }}</span>
                    </div>
                </mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
                <div class="metrics-grid">
                    <div *ngFor="let metric of selectedMetrics" class="metric-item">
                        <div class="metric-header">
                            <span class="metric-name">{{ getMetricDisplayName(metric) }}</span>
                            <mat-icon [style.color]="uni.metrics[metric].color" class="metric-icon">
                                {{ uni.metrics[metric].icon }}
                            </mat-icon>
                        </div>

                        <div class="metric-score">
                            <span class="score">{{ uni.metrics[metric].value }}</span>
                            <mat-progress-bar [value]="uni.metrics[metric].value" [color]="uni.metrics[metric].color === '#4caf50' ? 'primary' :
                        uni.metrics[metric].color === '#ff9800' ? 'accent' : 'warn'" class="score-bar">
                            </mat-progress-bar>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- Summary Section -->
    <div class="summary-section">
        <h3>Comparison Summary (Yours compared to others)</h3>
        <div class="summary-stats">
            <div class="stat-item">
                <mat-icon>emoji_events</mat-icon>
                <div class="stat-content">
                    <span class="stat-label">Top Performer</span>
                    <span class="stat-value">{{ processedUniversities[0]?.name }}</span>
                </div>
            </div>

            <div class="stat-item">
                <mat-icon>analytics</mat-icon>
                <div class="stat-content">
                    <span class="stat-label">Average Score</span>
                    <span class="stat-value">
                        {{ getAverageScore() }}
                    </span>
                </div>
            </div>

            <div class="stat-item">
                <mat-icon>trending_up</mat-icon>
                <div class="stat-content">
                    <span class="stat-label">Score Range</span>
                    <span class="stat-value">
                        {{ getScoreRange() }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
